export const truthConverter = { f: false, t: true, undefined: false }

export const openInNewTab = (url) => window.open(url, "_blank", "noreferrer noopener")

export const toggleReducer = (state, action = !!!state) => action

export const byteToMB = (bytes) => { return (bytes / 1024 / 1024).toFixed(2) }
